
import MENU_AU from '@data/components/navigation.au.json'
import MENU_UK from '@data/components/navigation.uk.json'

type NavigationDataType = {
  [key in 'au' | 'uk']: [{
    id?: string
    title: string
    url?: string
    submenu?: string
  }]
}

export default {
  'au': MENU_AU,
  'uk': MENU_UK,
} as NavigationDataType